import styled from 'styled-components';

export const Flex = styled.div<{ flexDirection?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${props => props.flexDirection};
  > :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const Circle = styled.div`
  width: 128px;
  height: 128px;
  background-color: #fbf7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;

export const StyledShowMoreButton = styled.button`
  display: block;
  width: 141px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid #4c458a;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 77px;
  margin-left: auto;
  margin-right: auto;
`;
